import './style.css'
import 'vite/modulepreload-polyfill'
import * as Turbo from "@hotwired/turbo"
import { Application } from "@hotwired/stimulus"
import { registerControllers } from 'stimulus-vite-helpers'

// Setup Turbo
Turbo.connectStreamSource(new WebSocket("ws://" + document.location.host + "/ws"))
Turbo.connectStreamSource(new EventSource("/sse"));

// Setup Stimulus application
const application = Application.start()

// Register controllers
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(application, controllers)

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application
export { application }